import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useChat } from "@/contexts/ChatContext";

export const AskCircleMobileFab = () => {
  const { openChat, expandChat, hasStartedConversation, isChatOpen, isChatMinimized } = useChat();

  // Hide FAB when chat is fully open (not minimized)
  const shouldHideFab = isChatOpen && !isChatMinimized;

  // Show the dynamic button: green "What should I buy?" or yellow chat bubble
  return (
    <div className="md:hidden fixed bottom-6 left-4 z-40 animate-fade-in">
      {!hasStartedConversation ? (
        <Button 
          onClick={() => openChat()}
          size="lg"
          className="bg-emerald-600 hover:bg-emerald-700 text-white shadow-lg hover:shadow-xl transition-all duration-200 rounded-full px-4 py-6 gap-2 font-semibold hover:scale-105"
        >
          <MessageCircle className="h-5 w-5" />
          <span className="text-sm">What should I buy?</span>
        </Button>
      ) : !shouldHideFab ? (
        <Button
          onClick={() => expandChat()}
          size="icon"
          className="h-14 w-14 rounded-full shadow-lg hover:shadow-xl transition-all bg-primary hover:bg-primary/90"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-6 w-6 text-black"
          >
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
        </Button>
      ) : null}
    </div>
  );
};
